
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, Mail, User, Lock } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Label } from "@/components/ui/label";

const RegisterTab = () => {
  const [regUsername, setRegUsername] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regShowPassword, setRegShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const { toast } = useToast();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Registration is disabled for security
    toast({
      title: "Registracija nije dozvoljena",
      description: "Registracija novih korisnika trenutno nije dostupna. Kontaktirajte administratora.",
      variant: "destructive",
    });
  };

  return (
    <form onSubmit={handleRegister} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="reg-username">Korisničko ime</Label>
        <div className="relative">
          <User className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
          <Input
            id="reg-username"
            placeholder="Odaberite korisničko ime"
            value={regUsername}
            onChange={(e) => setRegUsername(e.target.value)}
            className="bg-black/50 border-primary/20 text-foreground pl-10 focus:border-primary"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="reg-email">Email adresa</Label>
        <div className="relative">
          <Mail className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
          <Input
            id="reg-email"
            type="email"
            placeholder="Vaša email adresa"
            value={regEmail}
            onChange={(e) => setRegEmail(e.target.value)}
            className="bg-black/50 border-primary/20 text-foreground pl-10 focus:border-primary"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="reg-password">Lozinka</Label>
        <div className="relative">
          <Lock className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
          <Input
            id="reg-password"
            type={regShowPassword ? "text" : "password"}
            placeholder="Kreirajte sigurnu lozinku"
            value={regPassword}
            onChange={(e) => setRegPassword(e.target.value)}
            className="bg-black/50 border-primary/20 text-foreground pl-10 pr-10 focus:border-primary"
          />
          <button
            type="button"
            onClick={() => setRegShowPassword(!regShowPassword)}
            className="absolute right-3 top-2.5 text-muted-foreground hover:text-foreground"
          >
            {regShowPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>
      <Button
        type="submit"
        className="w-full bg-secondary hover:bg-secondary/90 text-primary-foreground font-bold"
        disabled={isLoading}
      >
        {isLoading ? "Registracija u tijeku..." : "KREIRAJ RAČUN"}
      </Button>
    </form>
  );
};

export default RegisterTab;
